import { createSlice } from "@reduxjs/toolkit";

const infoModalSlice = createSlice({
  name: "infoModal",
  initialState: {
    isOpen: false,
  },
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openModal, closeModal } = infoModalSlice.actions;
export default infoModalSlice.reducer;